import * as React from "react"
import {Link} from "react-router-dom"

// For using an image under 10k in size we have three choices:
// 1. Use an image import/require here (per usual) and rely on our CSP having
// `img-src 'self' data: ...` (which it does now, see server.include.nginx and
// https://security.stackexchange.com/a/167244) because images less than 10k are inlined, as a
// data URI: see "Adding Images, Fonts, and Files" in the Create React App (CRA) User Guide.
// 2. Stick the image under the `public` dir and access it directly, which is what we do below. For
// the pros and cons of this method see "Using the public Folder", also in the CRA User Guide.
// 3. I guess we could eject from CRA and tell Webpack not to inline small images.

// TODO For now we choose Method 2
const headBg = process.env.PUBLIC_URL + "/images/headBg.png"
const headImg = process.env.PUBLIC_URL + "/images/logo.png"

const headStyle = {
  background: `#fff url('${headBg}') 0 0 repeat-x`,
}

// This file relies on legacy CSS defines in index.css.  Inlining it here was non trivial
// so it can wait.
export function Logo() {
  return (
    <header id="head" style={headStyle}>
      <Link to="/">
        <img id="logo" src={headImg} alt="C U Soon Chauffeur Melbourne Logo" />
      </Link>
      <div id="design">
        {/*<a href="http://www.conradesign.com.au/" rel="nofollow">*/}
          logo design by conrad design
        {/*</a>*/}
      </div>
    </header>
  )
}



// WEBPACK FOOTER //
// ./src/components/Logo.tsx